import React from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import './../../css/VirtualPlayer.css';
import * as PANOLENS from './panolens.js';
import * as THREE from 'three';
import Typed from './typed.min.js';
import { auth, db, storage } from './../../services/firebase';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ButtonGroup, Toast, Popover, OverlayTrigger, Modal } from 'react-bootstrap';
import firebase from 'firebase';
import { isMobile } from 'react-device-detect';
import { FacebookShareButton, TwitterShareButton, WhatsappShareButton, RedditShareButton } from "react-share";
import VProfileImage from '../../components/ProfileImage/ProfileImage.js';
import VInfoModal from '../../components/InfoModal/InfoModal.js';
import ReactPlayer from 'react-player'
import { Fade } from 'react-animation-components'
import {
	Link
} from "react-router-dom";

import { withStyles } from '@material-ui/core/styles';
import { Menu, MenuList, MenuItem, ListItemIcon, ListItemText, Paper, Popper, Grow, ClickAwayListener, Slider, Text } from '@material-ui/core';
import SettingsIcon from '@material-ui/icons/Settings';
import FastForwardIcon from '@material-ui/icons/FastForward';
import ReplayIcon from '@material-ui/icons/Replay';
import InfoIcon from '@material-ui/icons/Info';
import ChatIcon from '@material-ui/icons/Chat';
import MusicNoteIcon from '@material-ui/icons/MusicNote';
import MusicOffIcon from '@material-ui/icons/MusicOff';
import SpeedIcon from '@material-ui/icons/Speed';
import TextRotationNoneIcon from '@material-ui/icons/TextRotationNone';
import InnerHTML from 'dangerously-set-html-content'
import ReactNoSleep from 'react-no-sleep';
import NoSleep from 'nosleep.js';


/////////////GAMECODER

var noSleep = new NoSleep();

var ended;
var reactObj = null;

var viewer;
var typed;
var tweeningDelay = 300, typeStartDelay = 1000, typeSpeed = 60;
var actualJson;

var config = {
	spotImage: "https://firebasestorage.googleapis.com/v0/b/virtualizalo-gc.appspot.com/o/player%2FBoton_Info2_64.png?alt=media&token=34927313-7a06-457f-a0d7-46393655a480",
	msgImage: "https://firebasestorage.googleapis.com/v0/b/virtualizalo-gc.appspot.com/o/player%2FBoton_Comentario2_64.png?alt=media&token=dc18dc0e-f325-4f3e-934a-e3ce43d6ccf1",
	linkImage: "https://firebasestorage.googleapis.com/v0/b/virtualizalo-gc.appspot.com/o/player%2FBoton_Movimiento2_64.png?alt=media&token=032200ec-66d5-4dd8-ba0d-57b0fab87461",
	music: "https://firebasestorage.googleapis.com/v0/b/virtualizalo-gc.appspot.com/o/player%2FKrishna_s_Calliope.mp3?alt=media&token=0337f3e4-d551-405f-862c-fdbdd5fcdca6",
	enableCursorImage: "https://firebasestorage.googleapis.com/v0/b/virtualizalo-gc.appspot.com/o/player%2FIcono_CursorMovimiento.gif?alt=media&token=2e64ecbb-42c6-41d4-8fbd-9918d3a2b57c",
	disableCursorImage: "https://firebasestorage.googleapis.com/v0/b/virtualizalo-gc.appspot.com/o/player%2FIcono_CursorBloqueado.gif?alt=media&token=9889c30b-e1d8-4071-ac02-210f03e79dc8"
}

var infoVisible = false;
var msgVisible = false;
var progressElement = null;
var questionElement = null;
var clicked = false;
var timeoutJump = null;

var delayExecuteHandlers;

var docRef;
var userRef = null;
var CID;
var PID;
var AID;
var answersGlobal;
var panoramaLinkedSpotsFlag = {};
var globalJson;

var msgPosting = false;
var msgPoint = null;
var msgSpots = [];
var msgData;
var msgRootIDs;

var userData = null;
var userImgData = {};

var canSkip;

function delayExecute(func, delay) {
	delayExecuteHandlers.push(setTimeout(func, delay));
}

function showAllInfoSpots(visible) {
	infoVisible = visible;
	for (let key in actualJson.spots) {
		if(actualJson.spots[key].obj!=null){
			if (visible) {
				actualJson.spots[key].obj.show();				
			} else {
				actualJson.spots[key].obj.hide();				
			}
		}
	}
}

function showAllMsgSpots(visible) {
	msgVisible = visible;

	for (var i = 0; i < msgSpots.length; i++) {
		if (visible) {
			msgSpots[i].show();
		} else {
			msgSpots[i].hide();
		}
	}
}

function startVideo(){
	reactObj.setState({videoActive: true })
}

function restartVideo(){	
	showAllInfoSpots(false);
	setTimeout(startVideo, 500);
	setTimeout(removeVideo, reactObj.state.videoLength+15000);
}

function removeVideo(){	
	showAllInfoSpots(true);
	reactObj.setState({videoActive: false });
}

function fadeStart(){	
	if(viewer.lookAt){
		viewer.tweenControlCenter(viewer.lookAt);
	}
}

function onEnter(dataJsonTitle, title, video, jumpTime, jumpLink) {
	if (ended) {
		return;
	}

	if (PID == null || PID.length <= 0) {
		//viewer.toggleControlBar();
	}

	processPanorama(title, globalJson, false);

	PID = title;
	console.log("onEnter", title);

	progressElement.style.width = 0;
	progressElement.classList.remove('finish');
	if (document.querySelector('#dialog')) {
		document.querySelector('#dialog').classList.remove('finish');
		document.querySelector('#typed').innerHTML = "";
	}
	questionElement.innerHTML = "";
	viewer.OrbitControls.enabled = true;
	reactObj.setState({ canMove: true });

	actualJson = dataJsonTitle;
	makeHistory(dataJsonTitle, onEnd, 1200, 0);

	reactObj.getAllMsg();
	showAllInfoSpots(false);

	console.log("visited", reactObj.state.visited);
	if (reactObj.state.visited && reactObj.state.visited.indexOf(CID + "." + PID) == -1) {
		db.runTransaction(function (transaction) {
			// This code may get re-run multiple times if there are conflicts.
			return transaction.get(docRef).then(function (doc) {
				if (!doc.exists) {
					throw "Document does not exist!";
				}

				var data = doc.data();
				var value = data.visits;
				transaction.update(docRef, { visits: value + 1 });
			});
		}).then(function () {
			console.log("Transaction successfully committed!");
		}).catch(function (error) {
			console.error("Transaction failed: ", error);
		});
	}

	let skipped = false;
	if (canSkip) {
		if (userData && userData.visited && userData.visited.indexOf(CID + "." + PID) != -1) {
			//delayExecute(() => { skip() }, 300);
			skipped = true;
			skip();
		} else
			if (reactObj.state.visited && reactObj.state.visited.indexOf(CID + "." + PID) != -1) {
				//delayExecute(() => { skip() }, 300);
				skipped = true;
				skip();
			}
	}
	if (video != null && !skipped) {
		showAllInfoSpots(false);
		reactObj.setState({ videoUrl: video.url, videoLength: video.length, videoActive: true });
		setTimeout(removeVideo, video.length + 15000);
	}else{
		if(video!=null){
			reactObj.setState({ videoUrl:video.url, videoLength: video.length});
		}
	}
	if(jumpTime != 0){		
		timeoutJump = setTimeout(jumpToLink, jumpTime, jumpLink);
	}

	canSkip = true;
}

function jumpToLink(jumpLink)
{
	msgPosting = false;
	reactObj.setState({ msgShowFlag: "none" });
	if(timeoutJump!=null)
	{
		clearTimeout(timeoutJump);
		timeoutJump = null;
	}
	viewer.setPanorama(globalJson[jumpLink].obj);
}

function onProgress(event) {

	var progress = event.progress.loaded / event.progress.total * 100;
	progressElement.style.width = progress + '%';	
	if (progress === 100) {
		progressElement.classList.add('finish');
		reactObj.setState({loading: false});
	}else{
		reactObj.setState({loading: true});
	}
}

function skip() {
	if (typed) {
		typed.stop();
	}
	onEnd();
}

function runAll(data, firtBubble) {
	progressElement = document.querySelector('#progress');
	questionElement = document.querySelector("#question");

	// Viewer
	viewer = new PANOLENS.Viewer({
		container: document.querySelector('#virtualplayer'),
		controlBar: true,
		initialLookAt: new THREE.Vector3(0, 0, 5000),
		output: 'console',
		autoHideInfospot: false
	});




	//viewer.toggleControlBar();
	/*
		var skipControl = {
			style: {
				backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/virtualizalo-gc.appspot.com/o/player%2Fskip.png?alt=media&token=44588ea5-efda-4573-b713-9f5c735ada10)'
			},
	
			onTap: function () {
				if (PID && PID.length > 0) {
					skip();
				}
			}
		};
		viewer.appendControlItem(skipControl);
	
		var restartControl = {
			style: {
				backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/virtualizalo-gc.appspot.com/o/player%2Frestart.png?alt=media&token=aecdeb90-5f25-4c6b-acec-185fb1565d2e)'
			},
	
			onTap: function () {
				if (PID && PID.length > 0) {
					skip();
					canSkip = false;
					onEnter(actualJson, PID);
				}
			}
		};
		viewer.appendControlItem(restartControl);
	
		var infoControl = {
			style: {
				backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/virtualizalo-gc.appspot.com/o/player%2Finfo.png?alt=media&token=bb9ead2c-e5b1-4371-a9bb-67e364cd6082)'
			},
	
			onTap: function () {
				if (PID && PID.length > 0) {
					showAllInfoSpots(!infoVisible);
				}
			}
		};
		viewer.appendControlItem(infoControl);
	
		var msgControl = {
			style: {
				backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/virtualizalo-gc.appspot.com/o/player%2Fmsg.png?alt=media&token=09001f67-5be3-4272-a86b-f7def1371eaa)'
			},
	
			onTap: function () {
				if (PID && PID.length > 0) {
					let vis = !msgVisible;
					showAllMsgSpots(vis);
					reactObj.setState((prev) => {
						if (vis) {
							msgPosting = true;
							return { msgShowFlag: "inline" };
						} else {
							msgPosting = false;
							return { msgShowFlag: "none" };
						}
					});
				}
			}
		};
		viewer.appendControlItem(msgControl);
	
		var musicControl = {
			style: {
				backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/virtualizalo-gc.appspot.com/o/player%2Fmusic.png?alt=media&token=00f21596-164a-4d71-9ef5-447504f9cd24)',
			},
	
			onTap: function () {
				if (reactObj && reactObj.audio) {
					if (reactObj.audio.paused) {
						reactObj.audio.play();
					} else {
						reactObj.audio.pause();
					}
				}
			}
		};
		viewer.appendControlItem(musicControl);
	*/

	panoramaLinkedSpotsFlag = {};
	globalJson = JSON.parse(data);
	var first = function() { for (var k in globalJson) return k }();	
	if(firtBubble !=null && firtBubble!=""){
		first = firtBubble;
	}	
	processPanorama(first, globalJson, true);
	//processData(json);
}

function onEnd() {
	viewer.OrbitControls.enabled = true;
	reactObj.setState({ canMove: true });
	document.querySelector('#dialog').classList.add('finish');
	showAllInfoSpots(true);

	if (userData && userData.visited && userData.visited.indexOf(CID + "." + PID) == -1) {
		userData.visited.push(CID + "." + PID);
		userRef.update({
			visited: firebase.firestore.FieldValue.arrayUnion(CID + "." + PID)
		});
	}
	console.log("ENEND");
	reactObj.setState(prev => {
		if (prev.visited.indexOf(CID + "." + PID) == -1) {
			prev.visited.push(CID + "." + PID);
		}
		return { visited: prev.visited };
	});
}


function makeHistory(dataJson, onComplete, startDelay, index = 0) {

	if (ended) {
		return;
	}

	if(dataJson.flow == null){
		console.error("ERROR - NO FLOW IN -> "+ PID);
		return;
	}

	if (dataJson.flow[index].spot) {
		delayExecute(dataJson.spots[dataJson.flow[index].spot].obj.focus.bind(dataJson.spots[dataJson.flow[index].spot].obj), tweeningDelay);
	}

	let answers = false;

	if (dataJson.flow[index].answer != null && dataJson.answers != null && dataJson.answers[dataJson.flow[index].answer] != null) {
		reactObj.setState({ answers: dataJson.answers[dataJson.flow[index].answer] });
		AID = dataJson.flow[index].answer;
		answersGlobal = dataJson.answers[dataJson.flow[index].answer];
		answers = true;
	}

	if (ended) {
		return;
	}
	typed = new Typed("#typed", {

		strings: dataJson.texts[dataJson.flow[index].text],
		typeSpeed: typeSpeed,
		showCursor: false,
		startDelay: startDelay,
		onComplete: function () {
			let tIdx = index + 1;
			if (tIdx < dataJson.flow.length) {
				makeHistory(dataJson, onComplete, startDelay, tIdx);
			} else {
				onComplete();
			}
		},
		onTypingPaused: function () {
			if (answers) {
				var questionElement = document.querySelector("#question");
				if (questionElement) {
					questionElement.classList.remove('finish');
				}
			}
		},
		onTypingResumed: function () {
			var questionElement = document.querySelector("#question");
			if (questionElement && !questionElement.classList.contains('finish')) {
				questionElement.classList.add('finish');
			}
		}

	});
}

function prepareTexts(dataJson) {
	for (var text in dataJson.texts) {
		dataJson.texts[text].unshift('');
		dataJson.texts[text].push('');
	}
}

function createElementFromStr(htmlString) {
	var div = document.createElement('div');
	div.innerHTML = htmlString.trim();

	// Change this to div.childNodes to support multiple top-level nodes
	return div.firstChild;
}

function createSpots(dataJson) {	
	for (var spot in dataJson.spots) {		
		createSingleSpot(spot, dataJson);
	}
}

async function createSingleSpot(spot, dataJson)
{
	let spotImg = config.spotImage;
	if (dataJson.spots[spot].link != null) {
		spotImg = config.linkImage;
	}
	if (dataJson.spots[spot].img != null) {
		spotImg = dataJson.spots[spot].img;
	}
	dataJson.spots[spot].obj = new PANOLENS.Infospot((dataJson.spots[spot].scale ? dataJson.spots[spot].scale : 300), spotImg);		
	if(dataJson.spots[spot].delayShow){
		dataJson.spots[spot].obj.delayShow = dataJson.spots[spot].delayShow;
	}
	if (dataJson.spots[spot].position) {
		dataJson.spots[spot].obj.position.set(dataJson.spots[spot].position[0], dataJson.spots[spot].position[1], -dataJson.spots[spot].position[2]);
	} else {
		if (dataJson.spots[spot].position2D) {
			var x = dataJson.spots[spot].position2D[0] * 2.0 * Math.PI - Math.PI / 2.0;
			var y = dataJson.spots[spot].position2D[1] * Math.PI;
			dataJson.spots[spot].obj.position.set(Math.sin(x) * 5000.0, Math.cos(y) * 5000.0, Math.cos(x) * 5000.0);
		}
	}
	if (dataJson.spots[spot].hoverText) {
		dataJson.spots[spot].obj.addHoverText(dataJson.spots[spot].hoverText, (dataJson.spots[spot].hoverDelta ? dataJson.spots[spot].hoverDelta : -40));
	}
	if (dataJson.spots[spot].html || dataJson.spots[spot].modalTitle) {
		let pinned = false;
		if (dataJson.spots[spot].pinned != null && dataJson.spots[spot].pinned == true) {
			pinned = true;
		}
		var innerHtml = dataJson.spots[spot].html
		var delta = dataJson.spots[spot].hoverDelta
		var isModal = false;
		if (dataJson.spots[spot].modalTitle) {
			innerHtml = '<div style=\"max-height: 150px;max-width: 300px\">' + dataJson.spots[spot].modalHtml + '<\/div>';
			delta = 50;
			isModal = true;
		}
		//innerHtml = "<div><div id=\"tlkio\" data-channel=\"Vinum\" data-theme=\"theme--minimal\" style=\"width:400px;height:600px;\"><\/div><script async src=\"http:\/\/tlk.io\/embed.js\" type=\"text\/javascript\"><\/script><\/div>";
		//innerHtml = "<a>asdasdasd<\/a>";			
		//!(viewer.mode == 2 && dataJson.spots[spot].videoStereo==true)
		//if(dataJson.spots[spot].videoStereo==true){
			console.log("##### viewer #####");
			console.log(viewer.mode);
			console.log(dataJson.spots[spot].videoStereo);
		//}
		if (innerHtml != null) {
			if(userData!=null && userData.username!=null){					
				innerHtml = innerHtml.replace("$virt.name$", userData.username + " (" + Math.floor(Math.random() * 1000)+ ")" );				
				//innerHtml = innerHtml.replace("$virt.name$", "vinum");				
			}				
			dataJson.spots[spot].obj.addHoverElement(createElementFromStr(innerHtml), (delta ? delta : -40), pinned, isModal, dataJson.spots[spot].videoStereo);
		}
	}

	if(dataJson.spots[spot].replayVideo){			
		let tempObj = dataJson.spots[spot].obj;			
		tempObj.addEventListener('click', function (e) {				
			restartVideo();
		});
	}

	if(dataJson.spots[spot].videoStereo){
		let tempObj = dataJson.spots[spot].obj;
		tempObj.addEventListener('click', function (e) {
			console.log("opening stereo");
			if(viewer.mode == 2){
				showAllInfoSpots(false);					
				reactObj.setState({stereoVideo:true})
			}
		});
	}			

	if(dataJson.spots[spot].toggleMusicButton){			
		let tempObj = dataJson.spots[spot].obj;			
		tempObj.addEventListener('click', function (e) {
			reactObj.optionsMusic();
		});
	}

	if(dataJson.spots[spot].toggleMessagesButton){			
		let tempObj = dataJson.spots[spot].obj;			
		tempObj.addEventListener('click', function (e) {
			reactObj.optionsMessage();
		});
	}		

	if(dataJson.spots[spot].restartButton){			
		let tempObj = dataJson.spots[spot].obj;			
		tempObj.addEventListener('click', function (e) {
			reactObj.optionsReplay();				
		});
	}

	if (dataJson.spots[spot].modalTitle) {

		reactObj.modals.push({ modalTitle: dataJson.spots[spot].modalTitle, modalHtml: dataJson.spots[spot].modalHtml })
		var id = reactObj.modals.length - 1;
		let tempObj = dataJson.spots[spot].obj;
		tempObj.modalId = id;
		tempObj.addEventListener('click', function (e) {
			tempObj.focus();
			tempObj.onHoverStart(e);
			//tempObj.lockHoverElement();
			reactObj.setState({ mainModalVisible: true, currentModal: tempObj.modalId });
		});

		if (dataJson.spots[spot].modalStart == true) {
			reactObj.setState({ mainModalVisible: true, currentModal: id });
		}

	} else {
		let tempObj = dataJson.spots[spot].obj;
		let isVideoStereo = dataJson.spots[spot].videoStereo;
		let lookPosition = new THREE.Vector3(dataJson.spots[spot].obj.position.x, dataJson.spots[spot].obj.position.y, dataJson.spots[spot].obj.position.z);
		if (dataJson.spots[spot].lookAt != null) {
			lookPosition = new THREE.Vector3(dataJson.spots[spot].lookAt[0], dataJson.spots[spot].lookAt[1], dataJson.spots[spot].lookAt[2]);
		}
		tempObj.addEventListener('click', function (e) {
			if(  !(viewer.mode == 2 && isVideoStereo==true) ){
				//tempObj.focus();
				//viewer.tweenControlCenter(lookPosition);
				viewer.lookAt = lookPosition;
				tempObj.onHoverStart(e);

				// Lock element
				tempObj.lockHoverElement();
			}
		});
	}

}


function addLinkEventsToSpots(dataJson) {
	for (var panoramaTitle in dataJson) {
		for (var spot in dataJson[panoramaTitle].spots) {
			let linkTitle = dataJson[panoramaTitle].spots[spot].link;
			if (linkTitle != null) {
				if (dataJson[linkTitle] == null) {
					console.warn("Bad format in Json - linking -> [" + spot + "] to [" + linkTitle + "]");
				}
				let linkObj = dataJson[linkTitle].obj;
				if (linkObj != null) {
					let spotObj = dataJson[panoramaTitle].spots[spot].obj;
					spotObj.addEventListener('click', function () {
						msgPosting = false;
						reactObj.setState({ msgShowFlag: "none" });
						if(timeoutJump!=null)
						{
							clearTimeout(timeoutJump);
							timeoutJump = null;
						}
						viewer.setPanorama(linkObj);
						delayExecute(() => {
							spotObj.unlockHoverElement();
							spotObj.onHoverEnd();
						}, 500);
					});
				}
			}
		}
	}
}

function addSpotsToPanorama(dataJson, panorama) {
	for (var spot in dataJson.spots) {
		panorama.add(dataJson.spots[spot].obj);
	}
}

function addLinksToPanorama(panoramaTitle, dataJson) {
	if(panoramaLinkedSpotsFlag[panoramaTitle]!=null){
		return;
	}
	panoramaLinkedSpotsFlag[panoramaTitle] = true;
	for (var spot in dataJson[panoramaTitle].spots) {
		setTimeout(addSimpleSpotLink, 5100, spot, dataJson, panoramaTitle);
	}
}

function addSimpleSpotLink(spot, dataJson,panoramaTitle){
	let linkTitle = dataJson[panoramaTitle].spots[spot].link;
	if (linkTitle != null) {
		if (dataJson[linkTitle] == null) {
			console.warn("Bad format in Json - linking -> [" + spot + "] to [" + linkTitle + "]");
		}
		let linkObj = dataJson[linkTitle].obj;
		if (linkObj != null) {
			let spotObj = dataJson[panoramaTitle].spots[spot].obj;
			spotObj.addEventListener('click', function () {
				msgPosting = false;
				reactObj.setState({ msgShowFlag: "none" });
				if(timeoutJump!=null)
				{
					clearTimeout(timeoutJump);
					timeoutJump = null;
				}
				viewer.setPanorama(linkObj);
				delayExecute(() => {
					spotObj.unlockHoverElement();
					spotObj.onHoverEnd();
				}, 500);
			});
		}
	}	
}

async function createPanorama(panoramaTitle, dataJson){

	if(dataJson[panoramaTitle].obj!=null){
		return;
	}

	var panorama = null;
	let titleTemp = panoramaTitle;
	let video = dataJson[titleTemp].video;

	var src = dataJson[panoramaTitle].options.src;
	if (src.indexOf("/") != -1) {
		src = src.substring(src.lastIndexOf("/") + 1);
	}

	console.log("storage getting " + CID + '/' + src);
	var asset = storage.ref('virtual/' + CID + '/' + src);
	var url = await asset.getDownloadURL();

	if (dataJson[panoramaTitle].options.type == "StereoImagePanorama") {
		console.error("StereoImagePanorama not supported");
	}
	if (dataJson[panoramaTitle].options.type == "ImagePanorama" || dataJson[panoramaTitle].options.type == "StereoImagePanorama") {
		console.log("image 360 = " + panoramaTitle);
		panorama = new PANOLENS.ImagePanorama(url);
	} else if (dataJson[panoramaTitle].options.type == "VideoPanorama") {
		console.log("video 360 = " + panoramaTitle);
		panorama = new PANOLENS.VideoPanorama(url, { autoplay: true });
	}

	var jumpTime = 0;
	var jumpLink = "";
	if (dataJson[panoramaTitle].options.jumpTime){
		jumpTime = dataJson[panoramaTitle].options.jumpTime;
		jumpLink = dataJson[panoramaTitle].options.jumpLink;
	}

	panorama.addEventListener('progress', onProgress);
	panorama.addEventListener('enter-fade-complete', function () { onEnter(dataJson[titleTemp], titleTemp, video, jumpTime, jumpLink); });
	panorama.addEventListener('enter-fade-in-start', function () { fadeStart(); });
	console.log("Created panorama " + panoramaTitle);

	console.log("Preparing texts " + panoramaTitle);
	prepareTexts(dataJson[panoramaTitle]);
	console.log("Creating spots " + panoramaTitle);
	createSpots(dataJson[panoramaTitle]);
	console.log("Adding spots " + panoramaTitle);
	addSpotsToPanorama(dataJson[panoramaTitle], panorama);

	viewer.add(panorama);
	if (dataJson[panoramaTitle].options.initialLookAt != null) {		
		viewer.tweenControlCenter(new THREE.Vector3(dataJson[panoramaTitle].options.initialLookAt[0], dataJson[panoramaTitle].options.initialLookAt[1], dataJson[panoramaTitle].options.initialLookAt[2]), 0);		
	}

	console.log("creating obj = " + panoramaTitle + " <> " + panorama);
	dataJson[panoramaTitle].obj = panorama;

}

function DFSPanoramas(panoramaTitle, dataJson){
	var res = [];
	for (var spot in dataJson[panoramaTitle].spots) {
		let linkTitle = dataJson[panoramaTitle].spots[spot].link;
		if (linkTitle != null) {
			if (dataJson[linkTitle] == null) {
				console.warn("Bad format in Json - linking -> [" + spot + "] to [" + linkTitle + "]");
			}else{
				res.push(linkTitle);
			}
		}
	}
	return res;
}

async function processPanorama(panoramaTitle, dataJson, createFirst = false){
	if(createFirst){
		await createPanorama(panoramaTitle, dataJson);
	}
	var linkedPanoramas = DFSPanoramas(panoramaTitle, dataJson);
	for(var i=0; i<linkedPanoramas.length;i++){
		await createPanorama(linkedPanoramas[i], dataJson);
	}

	addLinksToPanorama(panoramaTitle, dataJson);
}

async function processData(dataJson) {

	//const stereo = new PANOLENS.Stereo(0.02);

	for (var panoramaTitle in dataJson) {
		var panorama = null;
		let titleTemp = panoramaTitle;
		let video = dataJson[titleTemp].video;

		var src = dataJson[panoramaTitle].options.src;
		if (src.indexOf("/") != -1) {
			src = src.substring(src.lastIndexOf("/") + 1);
		}

		console.log("storage getting " + CID + '/' + src);
		var asset = storage.ref('virtual/' + CID + '/' + src);
		var url = await asset.getDownloadURL();

		if (dataJson[panoramaTitle].options.type == "StereoImagePanorama") {
			console.error("StereoImagePanorama not supported");
		}
		if (dataJson[panoramaTitle].options.type == "ImagePanorama" || dataJson[panoramaTitle].options.type == "StereoImagePanorama") {
			console.log("image 360 = " + panoramaTitle);
			panorama = new PANOLENS.ImagePanorama(url);
		} else if (dataJson[panoramaTitle].options.type == "VideoPanorama") {
			console.log("video 360 = " + panoramaTitle);
			panorama = new PANOLENS.VideoPanorama(url, { autoplay: true });
		}

		var jumpTime = 0;
		var jumpLink = "";
		if (dataJson[panoramaTitle].options.jumpTime){
			jumpTime = dataJson[panoramaTitle].options.jumpTime;
			jumpLink = dataJson[panoramaTitle].options.jumpLink;
		}

		panorama.addEventListener('progress', onProgress);
		panorama.addEventListener('enter-fade-complete', function () { onEnter(dataJson[titleTemp], titleTemp, video, jumpTime, jumpLink); });
		panorama.addEventListener('enter-fade-in-start', function () { fadeStart(); });
		console.log("Created panorama " + panoramaTitle);

		console.log("Preparing texts " + panoramaTitle);
		prepareTexts(dataJson[panoramaTitle]);
		console.log("Creating spots " + panoramaTitle);
		createSpots(dataJson[panoramaTitle]);
		console.log("Adding spots " + panoramaTitle);
		addSpotsToPanorama(dataJson[panoramaTitle], panorama);

		viewer.add(panorama);
		if (dataJson[panoramaTitle].options.initialLookAt != null) {
			//viewer.tweenControlCenter(new THREE.Vector3(4947.87, 680.59, -49.44), 0);			
			viewer.tweenControlCenter(new THREE.Vector3(dataJson[panoramaTitle].options.initialLookAt[0], dataJson[panoramaTitle].options.initialLookAt[1], dataJson[panoramaTitle].options.initialLookAt[2]), 0);			
		}

		console.log("creating obj = " + panoramaTitle + " <> " + panorama);
		dataJson[panoramaTitle].obj = panorama;
	}

	addLinkEventsToSpots(dataJson);
}

function getPoint3D() {

	var intersects, point, panoramaWorldPosition, outputPosition;

	intersects = viewer.raycaster.intersectObject(actualJson.obj, true);

	if (intersects.length > 0) {

		point = intersects[0].point;
		panoramaWorldPosition = actualJson.obj.getWorldPosition();

		// Panorama is scaled -1 on X axis
		outputPosition = new THREE.Vector3(
			(point.x - panoramaWorldPosition.x).toFixed(2),
			(point.y - panoramaWorldPosition.y).toFixed(2),
			(point.z - panoramaWorldPosition.z).toFixed(2)
		);

		console.info(outputPosition.x + ', ' + outputPosition.y + ', ' + outputPosition.z);
		return [outputPosition.x, outputPosition.y, outputPosition.z];
	}
	return null;
}

function setMsg() {
	if (msgPosting && userData) {
		msgPoint = getPoint3D();
		reactObj.setState({ msgReplyID: null, msgModal: true, msgPointStr: ('[' + msgPoint[0] + ', ' + msgPoint[1] + ', ' + msgPoint[2] + ']') });
	}
}

const StyledMenu = withStyles({
	paper: {
		border: '1px solid #d3d4d5',
	},
})((props) => (
	<Menu
		elevation={0}
		getContentAnchorEl={null}
		anchorOrigin={{
			vertical: 'bottom',
			horizontal: 'center',
		}}
		transformOrigin={{
			vertical: 'top',
			horizontal: 'center',
		}}
		{...props}
	/>
));

const StyledMenuItem = withStyles((theme) => ({
	root: {
		'&:focus': {
			//backgroundColor: theme.palette.primary.main,
			'& .MuiListItemIcon-root, & .MuiListItemText-primary': {
				//color: theme.palette.common.white,
			},
		},
	},
}))(MenuItem);

function getConfigData(data) {
	if (data.config) {
		for (var c in data.config) {
			config[c] = data.config[c];
		}
	}
}

export default class VVirtualPlayerGood extends React.Component {

	constructor(props) {
		super(props);
		this.anchorRef = React.createRef();
		this.anchorRefShare = React.createRef();
		this.state = {
			answers: null,
			msgLoaded: false,
			msgShowFlag: "none",
			msgModal: false,
			msgPointStr: "",
			msgReplyID: null,
			canMove: null,
			optionsVisible: false,
			shareVisible: false,
			expanded: false,
			data: null,
			commentsNumber: "0",
			visited: [],
			mainModalVisible: false,
			currentModal: 0,
			videoUrl: null,
			videoLength: 10000,
			videoActive: false,
			stereoVideo: false,
			readyExitStereo: false,
			stereoHTML: null,
			loading: false
		};
		this.modals = [{ modalTitle: 'Modal', modalHtml: '' }];
		console.log('VP Props');
		console.log(props);
	}

	async getUserData(UID) {
		console.log("getting user -> ", UID);
		if (UID) {
			userRef = db.collection("users").doc(UID);

			await userRef.get().then(function (doc) {
				if (doc.exists) {
					userData = doc.data();
					userData._id = doc.id;
					userImgData[userData._id] = userData.photoUrl != null ? userData.photoUrl : "none";
					console.log("USER DATA", userData);
				} else {
					// doc.data() will be undefined in this case
					console.error("No such document! ");
				}
			}).catch(function (error) {
				console.error("Error getting document:", error);
			});

		}
	}

	async componentDidMount() {

		document.addEventListener('click', function enableNoSleep() {
			document.removeEventListener('click', enableNoSleep, false);
			noSleep.enable();
		  }, false);

		var qs = require('qs');		
		var currentSphere = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).sphereName;		
		document.body.style.overflow = "hidden";
		window.scrollTo(0, 1);

		reactObj = this;

		delayExecuteHandlers = [];
		canSkip = true;

		PID = "";

		CID = this.props.CID;
		if (this.props.match && this.props.match.params && this.props.match.params.CID) {
			CID = this.props.match.params.CID;
		}
		//Si esta mal el CID hay que poner uno default
		if (CID == null || CID.length <= 0) {
			CID = "exstudio";
		}

		var UID = this.props.UID;
		if (!UID && reactObj.props.userCallback()) {
			UID = reactObj.props.userCallback()._id;
		}
		console.log("vp USER", UID);
		await this.getUserData(UID);


		docRef = db.collection("content").doc(CID);

		docRef.get().then(function (doc) {
			if (doc.exists) {
				var data = doc.data();
				console.log("Document data:", data);
				reactObj.state.data = data;
				getConfigData(data);
				runAll(data.data, currentSphere);

				console.log("AUDIO", config.music);
				reactObj.audio.src = config.music;	
			} else {
				// doc.data() will be undefined in this case
				console.error("No such document!");
			}
		}).catch(function (error) {
			console.error("Error getting document:", error);
		});

		ended = false;

		this.audio = new Audio(config.music);
		this.audio.loop = true;
		this.audio.volume = .25;		
		//this.audio.play();
	
		if ( this.props.location.search.search("fullScreen") !=-1 && this.props.expanded == false){
			this.props.onFullscreenToggle();
		}
	}

	componentWillReceiveProps(newProps) {
		if (!userData) {
			var UID = newProps.UID;
			if (!UID && newProps.userCallback()) {
				UID = newProps.userCallback()._id;
			}
			this.getUserData(UID);
		}
	}

	componentWillUnmount() {
		ended = true;
		document.body.style.overflow = "visible";
		for (var i = 0; i < delayExecuteHandlers.length; i++) {
			clearTimeout(delayExecuteHandlers[i]);
		}

		if (typed) {
			clearTimeout(typed.pauseTimeout);
			//typed.pauseFunction();
		}

		if (this.audio) {
			this.audio.pause();
		}
	}

	postMsg(text) {
		// Hay que usar el UID de props (pasado como referencia antes de sacar el virtual player)
		if (userData) {
			var msgRef = db.collection("messages").doc();
			var data = {
				CID: CID,
				UID: reactObj.props.UID,
				PID: PID,
				date: Date.now(),
				likes: 0,
				parent: (reactObj.state.msgReplyID == null ? "" : reactObj.state.msgReplyID),
				position: [parseFloat(-msgPoint[0]), parseFloat(msgPoint[1]), parseFloat(msgPoint[2])],
				reported: 0,
				text: text
			}

			console.log("POSTING MSG ", data);

			msgRef.set(data).then(function () {
				reactObj.getAllMsg();
			});
		}
	}

	updateLike(value, data) {
		if (userData) {
			let likedValue = 0;
			if (value > 0) {
				if (userData.likedMessages == null) {
					userData.likedMessages = [];
				}
				if (userData.likedMessages.indexOf(data._id) == -1) {
					userData.likedMessages.push(data._id);
					likedValue++;
					userRef.update({
						likedMessages: firebase.firestore.FieldValue.arrayUnion(data._id)
					});
				}
				if (userData.dislikedMessages != null && userData.dislikedMessages.indexOf(data._id) != -1) {
					userData.dislikedMessages.splice(userData.dislikedMessages.indexOf(data._id), 1);
					likedValue++;
					userRef.update({
						dislikedMessages: firebase.firestore.FieldValue.arrayRemove(data._id)
					});
				}
			} else {
				if (userData.dislikedMessages == null) {
					userData.dislikedMessages = [];
				}
				if (userData.dislikedMessages.indexOf(data._id) == -1) {
					userData.dislikedMessages.push(data._id);
					likedValue--;
					userRef.update({
						dislikedMessages: firebase.firestore.FieldValue.arrayUnion(data._id)
					});
				}
				if (userData.likedMessages != null && userData.likedMessages.indexOf(data._id) != -1) {
					userData.likedMessages.splice(userData.likedMessages.indexOf(data._id), 1);
					likedValue--;
					userRef.update({
						likedMessages: firebase.firestore.FieldValue.arrayRemove(data._id)
					});
				}
			}
			if (likedValue != 0) {
				var msgRef = db.collection("messages").doc(data._id);
				db.runTransaction(function (transaction) {
					// This code may get re-run multiple times if there are conflicts.
					return transaction.get(msgRef).then(function (doc) {
						if (!doc.exists) {
							throw "Document does not exist!";
						}

						var data = doc.data();
						var likes = data.likes + likedValue;

						transaction.update(msgRef, { likes: likes });
					});
				}).then(function () {
					console.log("Transaction successfully committed!");
					reactObj.getAllMsg();
				}).catch(function (error) {
					console.error("Transaction failed: ", error);
				});
			}
		}
	}

	makeSingleMsg(data) {

		if (data == null) {
			return;
		}

		let childMsg = [];
		let date = new Intl.DateTimeFormat('es-MX').format(new Date(data.date));
		let spot = this.getSpot(data);

		for (var i = 0; i < data.childs.length; i++) {
			childMsg.push(this.makeSingleMsg(msgData[data.childs[i]]));
		}

		return <Toast key={data._id} style={{ maxWidth: "99%", pointerEvents: "auto", backgroundColor: 'transparent', borderColor: 'transparent', borderWidth: 3, borderRadius: '15px', fontFamily: 'BikoRegular' }}>
			<Toast.Header closeButton={false} style={{ backgroundColor: 'transparent' }}>
				<div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
					<div style={{ flex: 1, display: 'flex' }}>
						<VProfileImage
							size='40'
							url={(userImgData[data.UID] != null && userImgData[data.UID] != "none") ? userImgData[data.UID] : ""}
							ringSize='5'
						/>
						<div style={{ flex: 1, display: 'flex', flexDirection: 'row', marginLeft: 10, marginTop: 15 }}>
							<a style={{ color: 'white', textAlign: 'left' }}> {data.text} </a>
						</div>
					</div>
					<div style={{ flex: 1, display: 'flex', flexDirection: 'row', marginLeft: 40, alignContent: 'left', justifyContent: 'left', alignItems: 'left', justifyItems: 'left' }}>
						<strong className="mr-auto" style={{ color: 'lightGreen', flex: 1, display: 'flex', flexDirection: 'row', marginRight: 0, maxWidth: 150 }}>
							{userData ?
								<ButtonGroup aria-label="Basic example" size="sm">
									<Button style={{ backgroundColor: 'transparent', borderColor: 'transparent', width: 35 }} onClick={() => this.updateLike(-1, data)} size="sm" variant={(userData && userData.dislikedMessages && userData.dislikedMessages.indexOf(data._id) != -1) ? "danger" : "light"}>
										{userData && userData.dislikedMessages && userData.dislikedMessages.indexOf(data._id) != -1 &&
											<img style={{ maxWidth: 30 }} src={require("./images/Boton_Dislike_64.png")} alt="Third slide" />
										}
										{!(userData && userData.dislikedMessages && userData.dislikedMessages.indexOf(data._id) != -1) &&
											<img style={{ maxWidth: 20 }} src={require("./images/Boton_Dislike_64.png")} alt="Third slide" />
										}
									</Button>
									<Button style={{ backgroundColor: 'transparent', borderColor: 'transparent', width: 35 }} onClick={() => this.updateLike(1, data)} size="sm" variant={(userData && userData.likedMessages && userData.likedMessages.indexOf(data._id) != -1) ? "success" : "light"}>
										{userData && userData.likedMessages && userData.likedMessages.indexOf(data._id) != -1 &&
											<img style={{ maxWidth: 30 }} src={require("./images/Boton_Like_64.png")} alt="Third slide" />
										}
										{!(userData && userData.likedMessages && userData.likedMessages.indexOf(data._id) != -1) &&
											<img style={{ maxWidth: 20 }} src={require("./images/Boton_Like_64.png")} alt="Third slide" />
										}
									</Button>
								</ButtonGroup>
								: ""
							}
							<div style={{ flex: 1, display: 'flex', flexDirection: 'row', marginLeft: 10, marginTop: 7 }}>
								{data.likes} puntos.
								</div>
						</strong>
						<div style={{ flex: 1, display: 'flex', flexDirection: 'row', marginLeft: 0, marginTop: 5 }}>
							{userData ? <Button style={styles.transparentButton} size="sm" onClick={() => { msgPoint = data.position; this.setState({ msgReplyID: data._id, msgModal: true, msgPointStr: data.text }); }} variant="link">Responder</Button> : ""}
							<Button style={styles.transparentButton} size="sm" onClick={() => { if (spot) { spot.focus(); } }} variant="link">Ir al mensaje</Button>
							<a style={{ color: 'gray', fontSize: 8, marginTop: 10 }}>{date}</a>
						</div>
					</div>
				</div>
			</Toast.Header>
			<Toast.Body style={{ textAlign: "left", backgroundColor: 'transparent', color: 'white' }}>
				<div style={{ height: "10px" }}></div>
				<div style={{ marginLeft: 25 }}>
					{childMsg}
				</div>
			</Toast.Body>
		</Toast>;
	}

	getSpot(data) {
		if (data.parent == null || data.parent.length <= 0) {
			return data.spot;
		}
		return this.getSpot(msgData[data.parent]);
	}

	processAllMsg() {
		var res = [];
		if (this.state.msgLoaded) {
			console.log(msgData);
			console.log(msgSpots);
			for (var i = 0; i < msgRootIDs.length; i++) {
				res.push(this.makeSingleMsg(msgData[msgRootIDs[i]]));
			}
		}
		return res;
	}

	getAllMsg() {

		for (var i = 0; i < msgSpots.length; i++) {
			msgSpots[i].dispose();
		}

		msgData = {};
		msgSpots = [];
		msgRootIDs = [];
		var query = db.collection("messages").where("CID", "==", CID).where("PID", "==", PID).orderBy("likes", "desc");
		query.get().then(function (snapshot) {
			snapshot.forEach(async function (doc) {
				var data = doc.data();
				data._id = doc.id;
				data.childs = [];
				//Si no tiene padre es porque es una raiz de mensajes
				if (data.parent == null || data.parent.length <= 0) {
					// Se crea un spot
					var spot = new PANOLENS.Infospot(300, config.msgImage);
					if (data.position) {
						spot.position.set(data.position[0], data.position[1], data.position[2]);
					}
					if (data.text) {
						spot.addHoverText(data.text, -40);
					}
					actualJson.obj.add(spot);
					msgSpots.push(spot);
					data.spot = spot;
					msgRootIDs.push(doc.id);
				}

				msgData[doc.id] = data;

				if (userImgData[data.UID] == null) {
					console.log("IMAGE", data.UID);
					await db.collection("users").doc(data.UID).get().then(function (doc) {
						if (doc.exists) {
							var pURL = doc.data().photoUrl;
							userImgData[doc.id] = pURL ? pURL : "none";
							console.log("USER MSG DATA");
						} else {
							// doc.data() will be undefined in this case
							console.error("No such document! ");
						}
					}).catch(function (error) {
						console.error("Error getting document:", error);
					});
				}

			});

			for (var id in msgData) {
				if (msgData[id].parent != null && msgData[id].parent.length > 0) {
					msgData[msgData[id].parent].childs.push(id);
				}
			}

			console.log("a ver", userImgData);

			let numberCommentsText = '0';

			if (msgData != null && Object.keys(msgData).length > 0) {
				let numberComments = Object.keys(msgData).length;
				if (numberComments > 9) {
					numberCommentsText = '9+';
				} else {
					numberCommentsText = numberComments;
				}
			}

			showAllMsgSpots(msgVisible);
			reactObj.setState({ msgLoaded: true, commentsNumber: numberCommentsText });
		}).catch(function (error) {
			console.log("Error getting documents: ", error);
		});

	}

	questionClicked(idx) {
		if (!clicked) {
			clicked = true;
			questionElement.classList.add('finish');

			clearTimeout(typed.pauseTimeout);
			typed.pauseFunction();

			delayExecute(function () {
				//questionElement.innerHTML = "";
				clicked = false;
				reactObj.setState({ answers: null });
			}, 2000);

			db.runTransaction(function (transaction) {
				// This code may get re-run multiple times if there are conflicts.
				return transaction.get(docRef).then(function (doc) {
					if (!doc.exists) {
						throw "Document does not exist!";
					}

					var data = doc.data();
					var key = "answers." + AID;
					var value;

					if (data.answers[AID] == null) {
						var value = [];
						for (var i = 0; i < answersGlobal.length; i++) {
							if (idx == i) {
								value.push(1);
							} else {
								value.push(0);
							}
						}
					} else {
						var value = data.answers[AID];
						value[idx]++;
					}

					transaction.update(docRef, { [key]: value });
				});
			}).then(function () {
				console.log("Transaction successfully committed!");
			}).catch(function (error) {
				console.error("Transaction failed: ", error);
			});

		}
	}


	handleClick = (e) => {
		this.setState({ optionsVisible: e.currentTarget });
	};

	handleClose = () => {
		this.setState({ optionsVisible: null });
	}

	handleShareClick = (e) => {
		this.setState({ shareVisible: e.currentTarget });
	};

	handleShareClose = () => {
		this.setState({ shareVisible: null });
	}

	optionsMusic() {
		if (reactObj && reactObj.audio) {
			if (reactObj.audio.paused) {
				reactObj.audio.play();
			} else {
				reactObj.audio.pause();
			}
		}		
		reactObj.setState({ optionsVisible: null });
	}

	optionsExpand() {
		reactObj.props.onFullscreenToggle();
		reactObj.setState({ expanded: !reactObj.state.expanded });
	}	

	optionsMessage() {
		if (PID && PID.length > 0) {
			let vis = !msgVisible;
			showAllMsgSpots(vis);
			reactObj.setState((prev) => {
				if (vis) {
					msgPosting = true;
					return { msgShowFlag: "inline" };
				} else {
					msgPosting = false;
					return { msgShowFlag: "none" };
				}
			});
		}
		reactObj.setState({ optionsVisible: null });
	}

	optionsInfo() {
		if (PID && PID.length > 0) {
			showAllInfoSpots(!infoVisible);
		}
		reactObj.setState({ optionsVisible: null });
	}

	optionsSkip() {
		if (PID && PID.length > 0) {
			skip();
		}
		reactObj.setState({ optionsVisible: null });
	}

	optionsReplay() {
		if (PID && PID.length > 0) {
			skip();
			canSkip = false;
			onEnter(actualJson, PID);
		}
		reactObj.setState({ optionsVisible: null });
	}

	optionsMessageSpeed(e, value) {
		var v = 200 - value;
		typeSpeed = v;
		if (typed) {
			console.log(v);
			typed.typeSpeed = v;
		}
	}

	render() {
		let answers;

		if (this.state.answers != null) {
			answers = this.state.answers.map((answer, idx) =>
				<Button key={idx} variant="secondary" onClick={() => this.questionClicked(idx)} onTap={() => this.questionClicked(idx)}>{answer}</Button>
			);
		}

		if (this.state.wtf == true) {
			alert("wtf");
		}

		const popover = (
			<Popover id="popover-basic">
				<Popover.Content style={{ fontFamily: 'BikoRegular' }}>
					Para agregar un mensaje da <strong>doble-click</strong> en el lugar que quieras.
			  </Popover.Content>
			</Popover>
		);

		const popoverNoUser = (
			<Popover id='popover-basic'>
				<Popover.Content style={{ fontFamily: 'BikoRegular' }}>
					Tienes que estar <strong>registrado</strong> para escribir un mensaje.
		 		</Popover.Content>
			</Popover>
		);

		let infoImage;
		if (this.state.canMove != null) {
			if (this.state.canMove) {
				infoImage = <div id="infoImage" style={{ display: "inline", position: "fixed", zIndex: 1, overflow: "auto", top: 130, width: "50px", height: "50px", backgroundColor: "transparent" }}>
					<img src={config.enableCursorImage} width="50" />
				</div>
			} else {
				infoImage = <div id="infoImage" style={{ display: "inline", position: "fixed", zIndex: 1, overflow: "auto", top: 130, width: "50px", height: "50px", backgroundColor: "transparent" }}>
					<img src={config.disableCursorImage} width="50" />
				</div>
			}
		}

		let msgPanel;
		if (!isMobile) {
			msgPanel = <div onMouseEnter={() => { viewer.OrbitControls.noZoom = true; }} onMouseLeave={() => { viewer.OrbitControls.noZoom = false; }} className="blur scrollbar -webkit-scrollbar -webkit-scrollbar-thumb" style={{ display: this.state.msgShowFlag, position: "fixed", zIndex: 1, overflow: "auto", left: 0, width: "40%", height: "calc(100vh - 122px)", background: "linear-gradient(rgba(0,0,0,0.7),rgba(0,0,0,0.2))", borderColor: '#515151', borderWidth: 3, borderRadius: '15px' }} >
				<OverlayTrigger trigger="hover" placement="right" overlay={userData ? popover : popoverNoUser} >
					<Button style={{ borderColor: '#515151', borderWidth: 3, borderRadius: '15px', fontFamily: 'BikoBold', width: "40%", backgroundColor: '#3f3f3fdd', color: 'white', margin: 10, borderColor: 'white', borderWidth: 1, borderRadius: 10 }}>
						<img style={{ maxWidth: 25, marginRight: 5 }} src={require("./images/Boton_Comentario_64_2.png")} alt="Third slide" />
						Agregar comentario.
					</Button>
				</OverlayTrigger>
				{this.processAllMsg()}
			</div>
		} else {
			msgPanel = <div onTouchStart={() => { viewer.OrbitControls.enabled = false; }} onTouchEnd={() => { viewer.OrbitControls.enabled = true; }} className="blur" style={{ display: this.state.msgShowFlag, position: "fixed", zIndex: 1, overflow: "auto", left: 0, bottom: 55, width: "100%", height: "30%", background: "linear-gradient(rgba(0,0,0,0.7),rgba(0,0,0,0.2))" }} >
				<OverlayTrigger trigger="hover" placement="top" overlay={userData ? popover : popoverNoUser} >
					<Button style={{ width: "40%", backgroundColor: '#3f3f3fdd', color: 'white', margin: 10, borderColor: 'white', borderWidth: 1, borderRadius: 10 }}>{userData ? "+" : "-"}</Button>
				</OverlayTrigger>
				{this.processAllMsg()}
			</div>
		}

		let sharedTitle = "";
		if (this.state.data != null) {
			sharedTitle = this.state.data.name;
		}

		let tourDescription = "";
		if (this.state.data != null) {
			tourDescription = this.state.data.description;
		}

		let tourImage = "";
		if (this.state.data != null) {
			tourImage = this.state.data.bubbleUrl;
		}

		let fullVideo;
		if(this.state.videoActive && viewer.mode != 2){
			fullVideo = 
				<div
					onClick ={ () => {
						removeVideo();
					} }
					style={{position: 'absolute', left:0, top:0, width: '100%', height: '100%'}}
					>				
				<Fade in enterOpacity={0.0} exitOpacity={1.0} duration={1000} delay={this.state.videoLength} style={{ position: 'absolute', width: '100%', height: '100%', backgroundColor: 'black' }}>
					<Fade in enterOpacity={1.0} exitOpacity={0.0} duration={1000} style={{ position: 'absolute', width: '100%', height: '100%', backgroundColor: 'black' }}>
						<ReactPlayer muted={false} width={'100%'} height={'100%'} playing={true} url={this.state.videoUrl} />
					</Fade>
				</Fade>
			</div>
		} else {
			fullVideo = <div></div>
		}

		
		let stereoVideoInnerHtml = "    <script type=\"text\/javascript\" src=\"\/\/www.google.com\/jsapi\"><\/script>\r\n    <script type=\"text\/javascript\" src=\"https:\/\/apis.google.com\/js\/client.js?onload=onJSClientLoad\"><\/script>\r\n    <script src=\"https:\/\/www.youtube.com\/iframe_api\"><\/script>\r\n    <script type=\"text\/javascript\">\r\n      var player1;\r\n      var player2;      \r\n      var syncThreshold = 0.2;\r\n      var jumpThreshold = 2;\r\n      var jumpDeadTime = 500;\r\n      var timeSyncInterval;\r\n      var syncActionTimeout = undefined;\r\n\r\n      function onYouTubeIframeAPIReady() {\r\n        player1 = new YT.Player(\'somediv1\', {\r\n          videoId: \'Q1pXvALXjQs\',\r\n          width: \"40%\",\r\n          height: \"40%\",\r\n          events: {\r\n            onReady: syncTime,\r\n            onStateChange: syncStateChange\r\n          },\r\n          playerVars: {\r\n                \'autoplay\': 1,\r\n                \'controls\': 1,\r\n                \'showinfo\': 0,\r\n                \'modestbranding\': 0,\r\n                \'loop\': 1,\r\n                \'fs\': 0,\r\n                \'cc_load_policty\': 0,\r\n                \'iv_load_policy\': 3,\r\n                 \'mute\': 1\r\n            },\r\n        });\r\n        player2 = new YT.Player(\'somediv2\', {\r\n          videoId: \'Q1pXvALXjQs\',\r\n          width: \"40%\",\r\n          height: \"40%\"\r\n        });\r\n      }\r\n      \r\n      function syncTime() {    \r\n         \/\/player1.mute();\r\n       \/\/ player2.mute();\r\n        clearInterval(timeSyncInterval);\r\n        timeSyncInterval = setInterval(function() {\r\n          if (syncActionTimeout == undefined) {\r\n            var time1 = player1.getCurrentTime();\r\n            var time2 = player2.getCurrentTime();\r\n            var timeDifference = time2 - time1;\r\n            var timeDifferenceAmount = Math.abs(timeDifference);\r\n            var syncActionDuration = 1000 * timeDifferenceAmount \/ 2;\r\n            if (timeDifferenceAmount > jumpThreshold) {\r\n              console.log(\"Players are \" + timeDifferenceAmount + \" apart, Jumping.\");\r\n              player2.seekTo(player1.getCurrentTime());\r\n              syncActionTimeout = setTimeout(function() {\r\n                syncActionTimeout = undefined;\r\n              }, jumpDeadTime);\r\n            } else if (timeDifference > syncThreshold) {\r\n              console.log(\"Player 2 is \" + timeDifference + \"s ahead of player 1. Syncing.\");\r\n              player2.setPlaybackRate(0.5);\r\n              syncActionTimeout = setTimeout(function() {\r\n                player2.setPlaybackRate(1);\r\n                syncActionTimeout = undefined;\r\n              }, syncActionDuration);\r\n            } else if (timeDifference < -syncThreshold) {\r\n              console.log(\"Player 1 is \" + (-timeDifference) + \"s ahead of player 2. Syncing.\");\r\n              player2.setPlaybackRate(2);\r\n              syncActionTimeout = setTimeout(function() {\r\n                player2.setPlaybackRate(1);\r\n                syncActionTimeout = undefined;\r\n              }, syncActionDuration);\r\n            }\r\n          }\r\n        }, 1000);\r\n      }\r\n\r\n      function syncStateChange(e) {\r\n        if (e.data == YT.PlayerState.PLAYING) {\r\n          player2.seekTo(player1.getCurrentTime());\r\n          player2.playVideo();\r\n        } else if (e.data == YT.PlayerState.PAUSED) {\r\n          player2.seekTo(player1.getCurrentTime());\r\n          player2.pauseVideo();\r\n        }\r\n        player2.mute();\r\n      }\r\n      \r\n      \r\n    <\/script>\r\n\r\n<div style=\"width: 50%; background-color: blue\" >\r\n    <a style=\"position: absolute; left: 15%; bottom: 25%; font-size:8px; color: white\"> Reproduce con tu dedo el video de la izquierda.<\/a>\r\n  <a style=\"position: absolute; left: 65%; bottom: 25%; font-size:8px; color: white\"> Reproduce con tu dedo el video de la izquierda.<\/a>\r\n   <div style=\"position: absolute; left: 5%; top: 25%\"  id=\"somediv1\"><\/div>\r\n    <div style=\"position: absolute; right: 5%; top: 25%\" id=\"somediv2\"><\/div>\r\n  <\/div>"

		let stereoVideo;
		if(this.state.stereoVideo == true){
			stereoVideo = <div>								
					<div style={{ position: 'absolute', width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.7)' }}>
						<InnerHTML html={stereoVideoInnerHtml} />
					</div>					
					<div style={{ position: 'absolute', width: '20%', height: '100%', left:'50%', backgroundColor: 'transparent' }} 
					onClick ={ () => {
						console.log("Clicking stereo")
						if(this.state.readyExitStereo==false){
							console.log("Sending timeout")
							setTimeout(function() {
								console.log("Enabling  exit");
								reactObj.setState({readyExitStereo: true});
							}, 200);
						}
						if(this.state.readyExitStereo==true){
							showAllInfoSpots(true);
							this.setState({stereoVideo:false, readyExitStereo: false})
						}
					 } }/>
			</div>
		} else {
			stereoVideo = <div></div>
		}

		let loadingAnimation;
		if(this.state.loading){
			if(viewer.mode != 2){
				loadingAnimation =  <div style={{position:'absolute', width:'75px', height: '75px', backgroundColor:'transparent', left: '50%', top: '50%'}}>
										<img style={{ maxWidth: 75 }} src={require("./loading.gif")} alt="Third slide" />
										<a style={{fontSize: 20, fontFamily: 'BikoBold', color: 'white', alignSelf: 'center', marginLeft: -6}}>Cargando</a>
									</div>
			}else{
				loadingAnimation =  
				<div>
					<div style={{position:'absolute', width:'75px', height: '75px', backgroundColor:'transparent', left: '33%', top: '50%'}}>
						<img style={{ maxWidth: 75 }} src={require("./loading.gif")} alt="Third slide" />
						<a style={{fontSize: 20, fontFamily: 'BikoBold', color: 'white', alignSelf: 'center', marginLeft: -6}}>Cargando</a>
					</div>
					<div style={{position:'absolute', width:'75px', height: '75px', backgroundColor:'transparent', left: '66%', top: '50%'}}>
						<img style={{ maxWidth: 75 }} src={require("./loading.gif")} alt="Third slide" />
						<a style={{fontSize: 20, fontFamily: 'BikoBold', color: 'white', alignSelf: 'center', marginLeft: -6}}>Cargando</a>
					</div>
				</div>
			}
		}else{
			loadingAnimation = <div></div>
		}

		let playerHeight = "calc(100vh)";				
		if(this.props.expanded == true){
			playerHeight = "calc(100vh)";
		}

		//var bg=require('./locked.jpg');

		return (
			<div style={{ width: '100%', height: playerHeight, backgroundColor: '#303030', overflow: 'hidden', position: 'relative' }}>
			
				<div id="virtualplayer" onDoubleClick={setMsg} style={{ width: '100%', height: playerHeight, backgroundColor: '#303030', overflow: 'hidden', position: 'relative' }}>
					{infoImage}
					<div id="progress" style={{ width: "100%", height: "1px", backgroundColor: "#6600CC" }}></div>
					<div id="dialog" className="finish">
						<ul style={{ listStyleType: "none" }}>
							<li>
								<div id="typed" style={{ pointerEvents: "none" }}> </div>
							</li>
							<li id="typed">
								<ButtonGroup id="question" className="finish" aria-label="Basic example">
									{answers}
								</ButtonGroup>
							</li>
						</ul>
					</div>
					<InnerHTML html={"<script>\r\nvar premissionAsked = false;\r\ndocument.onclick= function(event) {\r\n    if(premissionAsked ==false){\r\n   premissionAsked = true;\r\n    console.log(premissionAsked);\r\n      DeviceMotionEvent.requestPermission();\r\n         }\r\n};\r\n<\/script>"} />
					<Modal show={this.state.msgModal} onHide={() => this.setState({ msgModal: false })} size="md" aria-labelledby="contained-modal-title-vcenter" centered style={{ opacity: 0.85, fontFamily: 'BikoRegular' }}>
						<Modal.Header closeButton style={{ backgroundColor: '#3f3f3f' }}>
							<Modal.Title style={{ color: '#ea2f64', fontFamily: 'BikoBold' }}>
								Nuevo Comentario
								{"   "}
								<small style={{ color: '#4cd8ca', fontSize: 16 }}>
									{this.state.msgPointStr}
								</small>
							</Modal.Title>
						</Modal.Header>
						<Modal.Body style={{ backgroundColor: '#3f3f3f' }} >
							<Form noValidate onSubmit={(e) => { e.preventDefault(); this.setState({ msgModal: false }); this.postMsg(this.refs.msgText.value); }}>
								<Form.Group controlId="msgPost">
									<Form.Label style={{ color: 'white' }}>Escribe tu comentario:</Form.Label>
									<Form.Control style={{ backgroundColor: '#222222', color: 'white' }} ref="msgText" as="textarea" rows="3" />
									<Button variant="primary" type="submit" style={{ marginTop: 10, marginLeft: 'auto', marginRight: 'auto', display: 'flex', backgroundColor: '#7144b7', borderColor: '#7144b7', fontFamily: 'BikoBlack' }}>
										PUBLICAR
									</Button>
								</Form.Group>
							</Form>
						</Modal.Body>
					</Modal>
					<Modal size="lg" centered={true} show={this.state.mainModalVisible} onHide={() => { this.setState({ mainModalVisible: false }) }} className="player_modal" >
						<Modal.Header closeButton>
							<Modal.Title>{this.modals[this.state.currentModal].modalTitle}</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<InnerHTML html={this.modals[this.state.currentModal].modalHtml} />
						</Modal.Body>
					</Modal>
					{msgPanel}

					<div style={{ display: "inline", position: "fixed", bottom: "10px", right: "10px" }}>
						{true &&
							<div style={{ display: "flex", flexDirection: 'row' }}>
								{ false &&
									<div style={{ marginRight: 10 }}>
										<Link onClick={this.optionsMessage}>
											<img style={{ maxWidth: 43 }} src={require("./images/Boton_Comentario_64_2.png")} alt="Third slide" />
										</Link>
										<div style={{ position: 'absolute', top: 15, left: 30 }}>
											<p ListItemText style={{ fontFamily: 'BikoBlack', fontSize: 25, marginTop: 'auto', marginBottom: 'auto', marginLeft: 0, display: 'flex', color: '#ea2f64' }}> {this.state.commentsNumber} </p>
										</div>
									</div>
								}
								<Button
									aria-controls="customized-menu"
									aria-haspopup="true"
									variant="info"
									onClick={this.handleClick}
									ref={this.anchorRef}
									style={{ backgroundColor: '#7144b7', borderRadius: '10px', borderColor: '#7144b7' }}
								>
									<img style={{ maxWidth: 30 }} src={require("./images/Reproductor_OpcionesBlanco_64.png")} alt="Third slide" />
								</Button>
								<ClickAwayListener onClickAway={this.handleClose}>
									<StyledMenu
										id="customized-menu"
										anchorEl={this.anchorRef.current}
										keepMounted
										open={Boolean(this.state.optionsVisible)}
										onClose={this.handleClose}
									>
										<StyledMenuItem onClick={this.optionsExpand} style={{ fontFamily: 'BikoBlack', fontSize: 16 }}>
											<ListItemIcon>
												<img style={{ maxWidth: 25, maxHeight: 25 }} src={require("./images/Reproductor_Expand.png")} alt="Third slide" />
											</ListItemIcon>
											<p ListItemText style={{ fontFamily: 'BikoRegular', fontSize: 20, marginTop: 'auto', marginBottom: 'auto', display: 'flex' }}> {this.props.expanded==true?'Reducir':'Agrandar'} </p>
										</StyledMenuItem>									
										<StyledMenuItem onClick={this.optionsMusic} style={{ fontFamily: 'BikoBlack', fontSize: 16 }}>
											<ListItemIcon>
												<img style={{ maxWidth: 25,  maxHeight: 25 }} src={require("./images/Reproductor_MusicaNegro_64.png")} alt="Third slide" />
											</ListItemIcon>
											<p ListItemText style={{ fontFamily: 'BikoRegular', fontSize: 20, marginTop: 'auto', marginBottom: 'auto', display: 'flex' }}> Música </p>
										</StyledMenuItem>
										<StyledMenuItem onClick={this.optionsMessage}>
											<ListItemIcon>
												<img style={{ maxWidth: 25,  maxHeight: 25 }} src={require("./images/Reproductor_ComentariosNegro_64.png")} alt="Third slide" />
											</ListItemIcon>
											<p ListItemText style={{ fontFamily: 'BikoRegular', fontSize: 20, marginTop: 'auto', marginBottom: 'auto', display: 'flex' }}> Ver Mensajes </p>
										</StyledMenuItem>
										<StyledMenuItem onClick={this.optionsInfo}>
											<ListItemIcon>
												<img style={{ maxWidth: 25,  maxHeight: 25 }} src={require("./images/Reproductor_InfoNegro_64.png")} alt="Third slide" />
											</ListItemIcon>
											<p ListItemText style={{ fontFamily: 'BikoRegular', fontSize: 20, marginTop: 'auto', marginBottom: 'auto', display: 'flex' }}> Ver Info </p>
										</StyledMenuItem>
										<StyledMenuItem onClick={this.optionsSkip}>
											<ListItemIcon>
												<img style={{ maxWidth: 25,  maxHeight: 25 }} src={require("./images/Reproductor_SaltarNegro_64.png")} alt="Third slide" />
											</ListItemIcon>
											<p ListItemText style={{ fontFamily: 'BikoRegular', fontSize: 20, marginTop: 'auto', marginBottom: 'auto', display: 'flex' }}> Saltar </p>
										</StyledMenuItem>
										<StyledMenuItem onClick={this.optionsReplay}>
											<ListItemIcon>
												<img style={{ maxWidth: 25, maxHeight: 25 }} src={require("./images/Reproductor_ReiniciarNegro_64.png")} alt="Third slide" />
											</ListItemIcon>
											<p ListItemText style={{ fontFamily: 'BikoRegular', fontSize: 20, marginTop: 'auto', marginBottom: 'auto', display: 'flex' }}> Reiniciar </p>
										</StyledMenuItem>
										<StyledMenuItem>
											<ListItemIcon>
												<img style={{ maxWidth: 25, maxHeight: 25 }} src={require("./images/Reproductor_TextoNegro_64.png")} alt="Third slide" />
											</ListItemIcon>
											<Slider
												defaultValue={200 - typeSpeed}
												aria-labelledby="discrete-slider"
												valueLabelDisplay="off"
												onChange={this.optionsMessageSpeed}
												step={10}
												marks
												min={90}
												max={190}
											/>
										</StyledMenuItem>
									</StyledMenu>
								</ClickAwayListener>
							</div>
						}
					</div>
					<div style={{ display: "inline", position: "fixed", bottom: "10px", left: "10px" }}>
						<div style={{ display: "flex", flexDirection: 'row' }}>
							<Button
								aria-controls="customized-menu"
								aria-haspopup="true"
								variant="info"
								onClick={this.handleShareClick}
								ref={this.anchorRefShare}
								style={{ backgroundColor: '#7144b7', borderRadius: '10px', borderColor: '#7144b7' }}
							>
								<img style={{ maxWidth: 30 }} src={require("./images/Reproductor_CompartirBlanco_64.png")} alt="Third slide" />
							</Button>
							<div style={{ marginLeft: 5, marginTop: 5 }}>
								<VInfoModal title={sharedTitle} description={tourDescription} img={tourImage} />
							</div>
							<p ListItemText style={{ fontFamily: 'BikoRegular', fontSize: 20, marginTop: 'auto', marginBottom: 'auto', marginLeft: -5, display: 'flex', color: 'white' }}> {sharedTitle} </p>
							<ClickAwayListener onClickAway={this.handleShareClose}>
								<StyledMenu
									id="customized-menu"
									anchorEl={this.anchorRefShare.current}
									keepMounted
									open={Boolean(this.state.shareVisible)}
									onClose={this.handleShareClose}
								>
									<StyledMenuItem >
										<ListItemIcon>
											<WhatsappShareButton url={window.location.href}
												title={"¡Visita virtualmente " + sharedTitle + " en Virtualízalo!"}
												windowWidth = {700}
												windowHeight = {700}
											>
												<img style={{ maxWidth: 45, marginLeft: 10, marginRight: 10 }} src={require("./images/IconoNegro_Whatsapp_64.png")} alt="Third slide" />
											</WhatsappShareButton>
										</ListItemIcon>
									</StyledMenuItem>
									<StyledMenuItem>
										<ListItemIcon>
											<TwitterShareButton url={window.location.href}
												title={"¡Visita virtualmente " + sharedTitle + " en Virtualízalo!"}
												hashtags={["virtualizalo"]}
												related={["@virtualizalo"]}
											>
												<img style={{ maxWidth: 45, marginLeft: 10, marginRight: 10 }} src={require("./images/IconoNegro_Twitter_64.png")} alt="Third slide" />
											</TwitterShareButton>
										</ListItemIcon>
									</StyledMenuItem>
									<StyledMenuItem >
										<ListItemIcon>
											<FacebookShareButton url={window.location.href}
												quote={"¡Visita virtualmente " + sharedTitle + " en Virtualizalo!"}
												hashtag={"#virtualizalo"}
											>
												<img style={{ maxWidth: 45, marginLeft: 10, marginRight: 10 }} src={require("./images/IconoNegro_Facebook_64.png")} alt="Third slide" />
											</FacebookShareButton>
										</ListItemIcon>
									</StyledMenuItem>
									<StyledMenuItem>
										<ListItemIcon>
											<RedditShareButton url={window.location.href}
												title={"¡Visita virtualmente " + sharedTitle + " en Virtualízalo!"}
											>
												<img style={{ maxWidth: 45, marginLeft: 10, marginRight: 10 }} src={require("./images/IconoNegro_Reddit_64.png")} alt="Third slide" />
											</RedditShareButton>
										</ListItemIcon>
									</StyledMenuItem>
								</StyledMenu>
							</ClickAwayListener>
						</div>
					</div>					
					{stereoVideo}
					{loadingAnimation}					
				</div>				
				{fullVideo}
			</div>			
		)
	}
}

const styles = {
	cancelButton: { borderColor: '#7144b7', borderRadius: '15px', backgroundColor: '#7144b7', fontFamily: 'BikoBlack', fontSize: 10, display: 'flex', color: 'white', marginLeft: 5, marginRight: 5 },
	transparentButton: { borderColor: 'transparent', backgroundColor: 'transparent', fontFamily: 'BikoRegular', fontSize: 12, display: 'flex', color: 'white', marginLeft: 1, marginRight: 1 },
};
